module.exports = __webpack_public_path__ + "2f4f83a42cd191d29270b15f62daca70.png";